<template>
  <div class="rescueList">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12" v-if="activeName === 'bigSickApply'"
            ><el-button
              @click="exportList"
              :loading="btnExportLoading"
              v-access:modify
              size="small"
              icon="el-icon-download"
              >导出</el-button
            ></el-col
          >
          <el-col :span="12" v-else>&#12288;</el-col>
          <el-col :span="12">
            <div class="search-box">
              <el-input
                style="width: 290px;margin-right: 10px;"
                clearable
                v-model="searchModel.searchKey"
                placeholder="关键字"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="btnSearch"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="大病医疗救助登记表" name="bigSickApply">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="bigSickApplyModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="BusinessId"
                label="编号"
                width="220"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="申请人姓名"
                width="110"
                align="left"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="求助人联系电话"
                width="140"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Describe"
                label="求助原因"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Amount"
                label="资助金额(元)"
                width="120"
                align="right"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="CreateTime"
                label="登记时间"
                width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ (scope.row.CreateTime * 1000) | formatDate2 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="FundTime"
                label="资助时间"
                width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ (scope.row.FundTime * 1000) | formatDate2 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Unit"
                label="资助单位"
                align="center"
                width="140"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerQuery(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >资助</el-button
                  >
                  <el-button
                    v-access:read
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >资助明细</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="其他救助登记表" name="seekHelpApply">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="seekHelpApplyModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="BusinessId"
                label="编号"
                width="200"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="姓名"
                width="120"
                align="left"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Sex"
                label="性别"
                width="60"
                align="center"
                :formatter="showSex"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="手机号"
                width="120"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Address"
                label="联系地址"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Type"
                label="求助类型"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="State"
                label="状态"
                :formatter="showState"
              ></el-table-column>
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="gotoSeekInfo(scope.row)"
                    type="text"
                    size="mini"
                    v-access:read
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >资助</el-button
                  >
                  <el-button
                    v-access:read
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >资助明细</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="scope.row.IsReceiving == 0 && scope.row.ExpressNo"
                    @click="innerrecipt(scope.row)"
                    type="text"
                    size="mini"
                    >确认收货</el-button
                  >
                  <el-button
                    v-if="scope.row.State === 0"
                    v-access:modify
                    type="text"
                    size="mini"
                    @click="updateState(scope.row, 1)"
                    >收到材料</el-button
                  >
                  <el-button
                    v-if="scope.row.State === 1"
                    v-access:modify
                    type="text"
                    size="mini"
                    @click="updateState(scope.row, 2)"
                    >存档</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="searchModel.pageSize"
            :currentPage="searchModel.currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModelEdit
      v-if="formVisible"
      :applyModel="dataForm"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    >
    </ModelEdit>
    <ModelReceipt
      v-if="ReceiptVisible"
      :id="seekHelpApplyId"
      @formCallBack="seekHelpApplyCallBack"
    >
    </ModelReceipt>
    <ModelQuery v-if="showQuery" @formCallBack="QueryCallBack" :id="applyId">
    </ModelQuery>
    <SeekQuery
      v-if="showSeekQuery"
      @formSeekCallBack="SeekCallBack"
      :id="seekHelpApplyId"
    ></SeekQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import ModelEdit from "@/modules/zjrc/pages/rescue/edit";
import ModelReceipt from "@/modules/zjrc/pages/rescue/receipt";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModelQuery from "@/modules/zjrc/pages/rescue/bigsickapply/query";
import SeekQuery from "@/modules/zjrc/pages/rescue/seekHelp/query";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "rescueList",
  data() {
    return {
      showSeekQuery: "",
      headerRow: "header-row",
      isloading: false,
      formVisible: false,
      ReceiptVisible: false,
      showQuery: false,
      formTitle: "",
      placeholder: "请输入编号/申请人姓名", //搜索框提示
      activeName: "bigSickApply", //选项卡激活
      total: 0,
      searchModel: { searchKey: "", currentPage: 1, pageSize: 15 },
      bigSickApplyModel: [], //大病申请
      seekHelpApplyModel: [], //其他救助申请
      dataForm: {},
      seekHelpApplyId: "", //其他救助Id
      applyId: "", //申请id
      btnExportLoading: false,
    };
  },
  components: {
    BasePage,
    OfPagination,
    ModelEdit,
    ModelReceipt,
    ModelQuery,
    SeekQuery,
  },
  mounted() {
    let that = this;
    that.loadBigSickApply();
  },
  methods: {
    exportList() {
      const vm = this;
      vm.btnExportLoading = true;
      const param = { searchKey: vm.searchModel.searchKey };
      api.ExportBigSickApplyList(param).then((res) => {
        if (res.data.Code === 0) {
          saveAs(res.data.Data, "大病救助金发放登记表.xls");
        }
        vm.btnExportLoading = false;
      });
    },
    updateState(rowData, state) {
      let vm = this;
      this.$confirm("请确认是否改变状态？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          Id: rowData.Id,
          State: state,
        };
        api.UpdateState(params).then((rep) => {
          if (rep.data.Code === 0) {
            vm.$message({
              message: "修改成功",
              type: "success",
            });
            vm.searchModel.currentPage = 1;
            vm.loadSeekHelpApply();
          } else {
            vm.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //初始化数据
    loadBigSickApply() {
      let that = this;
      let params = {
        SearchKey: that.searchModel.searchKey,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.pageSize,
      };
      that.isloading = true;
      api.QueryBigSickApply(params).then((res) => {
        if (res.data.Code == 0) {
          that.bigSickApplyModel = res.data.Data.rows;
          that.total = res.data.Data.total;
          that.isloading = false;
        }
      });
    },
    loadSeekHelpApply() {
      let that = this;
      let params = {
        SearchKey: that.searchModel.searchKey,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.pageSize,
      };
      that.isloading = true;
      api.QuerySeekHelpApply(params).then((res) => {
        if (res.data.Code == 0) {
          that.seekHelpApplyModel = res.data.Data.rows;
          that.total = res.data.Data.total;
          that.isloading = false;
        }
      });
    },
    //查询
    search(searchKey) {
      this.searchModel.searchKey = searchKey;
    },
    btnSearch() {
      let that = this;
      if (that.activeName == "bigSickApply") {
        that.loadBigSickApply();
      } else {
        that.loadSeekHelpApply();
      }
    },
    //选项卡切换
    handleTabsClick(tab) {
      let that = this;
      that.searchModel.currentPage = 1;
      that.activeName = tab.name;
      switch (tab.name) {
        case "bigSickApply":
          that.loadBigSickApply();
          break;
        case "seekHelpApply":
          that.loadSeekHelpApply();
          break;
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //拨款
    innerEdit(rowData) {
      let that = this;
      that.dataForm = rowData;
      if (that.activeName == "bigSickApply") {
        that.formTitle = "大病医疗救助登记表";
      } else {
        that.formTitle = "其他救助登记表";
      }
      that.formVisible = true;
    },
    //确认收货
    innerrecipt(rowData) {
      let that = this;
      that.seekHelpApplyId = rowData.Id;
      that.ReceiptVisible = true;
    },
    //详情
    innerRead(rowData) {
      let that = this;
      that.applyId = rowData.Id;
      that.QueryVisible = true;

      that.$router.push({
        path: "/zjrc/sickgrant/list",
        query: { Id: rowData.Id },
      });
    },
    formCallBack(data) {
      let that = this;
      that.formVisible = false;
      if (data) {
        if (that.activeName == "bigSickApply") {
          that.loadBigSickApply();
        } else {
          that.loadSeekHelpApply();
        }
      }
    },
    //大病申请详情
    innerQuery(rowData) {
      let that = this;
      that.applyId = rowData.Id;
      that.showQuery = true;
    },
    QueryCallBack() {
      let that = this;
      that.showQuery = false;
    },

    SeekCallBack() {
      let vm = this;
      vm.showSeekQuery = false;
    },
    seekHelpApplyCallBack(data) {
      let that = this;
      that.ReceiptVisible = false;
      if (data) {
        that.loadSeekHelpApply();
      }
    },
    //性别展示
    showSex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    //状态展示
    showStatus(rowData) {
      switch (rowData.Status) {
        case 0:
          return "待审批";
        case 1:
          return "审批通过";
        case 2:
          return "审批不通过";
      }
    },
    showState(rowData) {
      switch (rowData.State) {
        case 0:
          return "待处理";
        case 1:
          return "已收到材料";
        case 2:
          return "已存档";
      }
    },
    //改变分页大小
    handleSizeChange(val) {
      let that = this;
      that.searchModel.currentPage = 1;
      that.searchModel.pageSize = val;
      switch (that.activeName) {
        case "bigSickApply":
          that.loadBigSickApply();
          break;
        case "seekHelpApply":
          that.loadSeekHelpApply();
          break;
      }
    },
    //改变当前页码
    handleCurrentChange(val) {
      let that = this;
      if (that.total > that.searchModel.pageSize) {
        that.searchModel.currentPage = val;
        switch (that.activeName) {
          case "bigSickApply":
            that.loadBigSickApply();
            break;
          case "seekHelpApply":
            that.loadSeekHelpApply();
            break;
        }
      }
    },
    gotoSeekInfo(rowData) {
      let that = this;
      that.seekHelpApplyId = rowData.Id;
      that.showSeekQuery = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.rescueList {
  .search-box {
    text-align: right;
    .toolBar-search {
      width: 300px;
      padding-right: 20px;
    }
  }
}
</style>